export const alphaRatedBorColor = [
    "rgba(204, 204, 204, 1)",
                "rgba(119, 255, 119, 1)",
                "rgba(119, 221, 187, 1)",
                "rgba(170, 170, 255, 1)",
                "rgba(255, 136, 255, 1)",
                "rgba(255, 204, 136, 1)",
                "rgba(255, 187, 85, 1)",
                "rgba(255, 119, 119, 1)",
                "rgba(255, 51, 51, 1)",
                "rgba(170, 0, 0, 1)",
]